<template>
  <mi-dialog
    :model-value="saveResultForLaterValue"
    :custom-design-dialog="true"
    no-backdrop-dismiss
  >
    <div class="save-result-for-later-dialog">
      <div>
        <div>
          <div class="save-result-for-later-header-wrapper">
            <h3 class="q-mt-none q-mb-lg save-result-for-later-header"> Save the result for later</h3>
            <div class="save-result-for-later-close-icon">
              <mi-btn
                icon="close"
                icon-type
                icon-size="21px"
                fab
                flat
                @click="handleCloseModal"
              ></mi-btn>
            </div>
          </div>
        </div>
        <div>
          <mi-text-field
            v-model="name"
            label="Save the results to see it later in Saved Tables"
            placeholder="Give this job a name"
            :error="error.status"
            :error-message="error.message"
            outlined
            required
          >
          </mi-text-field>
        </div>
      </div>

      <div class="save-result-for-later-btns-wrapper">
        <mi-btn flat @click="handleCloseModal"> Cancel </mi-btn>

        <mi-btn class="save-result-for-later-btn-save" @click="onSubmit()">
          Save
        </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  import { onMounted, ref } from 'vue'
  import MiDialog from '@/packages/@mi-library/MiDialog/MiDialog.vue'

  export default {
    name: 'SaveResultForLaterDialog',
    components: { MiDialog },
    props: {
      saveResultForLaterValue: {
        type: Boolean,
        required: false,
        default: false
      },
      handleCloseModal: {
        type: Function,
        required: true,
        default: () => {}
      },
      handleSubmit: {
        type: Function,
        required: true,
        default: () => {}
      }
    },
    setup(props) {
      const name = ref('')
      const error = ref({
        status: false,
        message: ''
      })

      const onSubmit = () => {
        if (name.value.length === 0) {
          error.value.status = true
          error.value.message = 'Mandatory field.'
          return
        }

        if (name.value.length > 100) {
          error.value.status = true
          error.value.message = 'Max 100 characters limit.'
          return
        }

        props.handleSubmit(name)
      }

      onMounted(() => {
        name.value = ''
        error.value.status = false
        error.value.message = ''
      })

      return {
        name,
        onSubmit,
        error
      }
    }
  }
</script>

<style lang="scss" >
  .save-result-for-later-dialog {
    width: 475px;
    height: 280px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .save-result-for-later-header-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .save-result-for-later-btns-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .save-result-for-later-btn-save {
    min-width: 156px;
  }
</style>
